"use strict";
/**
 * @ignore
 */

/** */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.eitherToFunction = exports.teToPromise = exports.promiseToTE = void 0;

var E = __importStar(require("fp-ts/lib/Either"));

var pipeable_1 = require("fp-ts/lib/pipeable");

var T = __importStar(require("fp-ts/lib/Task"));

var TE = __importStar(require("fp-ts/lib/TaskEither"));
/**
 * Convert a Promise<A> into a TaskEither<Error, A>
 *
 * @param fn - Function returning a Promise
 */


function promiseToTE(fn) {
  return TE.tryCatch(fn, function (reason) {
    var error = reason instanceof Error ? reason : new Error(String(reason));
    return error;
  });
}

exports.promiseToTE = promiseToTE;
/**
 * Convert a TaskEither<Error, A> into a Promise<A>
 *
 * @param fn - Function returning a Promise
 */

function teToPromise(te) {
  return new Promise(function (resolve, reject) {
    pipeable_1.pipe(te, TE.fold(function (error) {
      reject(error);
      return T.of(undefined);
    }, function (data) {
      resolve(data);
      return T.of(undefined);
    }))()["catch"](reject);
  });
}

exports.teToPromise = teToPromise;
/**
 * Convert an Either<Error, A> into a A, or throw if error
 */

function eitherToFunction(e) {
  return pipeable_1.pipe(e, E.fold(function (error) {
    throw error;
  }, function (data) {
    return data;
  }));
}

exports.eitherToFunction = eitherToFunction;